import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useTechDocsFeedbackReadAccess } from '../../hooks/useTechDocsFeedbackAccess';

export const TechDocsFeedbackSidebarItem = () => {
  const { canRead } = useTechDocsFeedbackReadAccess();
  if (!canRead) return null;
  return (
    <SidebarItem
      icon={FeedbackOutlinedIcon}
      to="/techdocs-feedback"
      text="Feedback"
      pluginId="techdocs-feedback"
    />
  );
};
